export const TREATMENT_TYPES = {
  IMMUNOTHERAPY_TREATMENT: 'immunotherapyTreatment',
  NUTRITION_ADVICE: 'nutritionAdvice',
};

export enum ImmunotherapyStepIds {
  BOOK_PREPARATORY_CONSULTATION = 'bookPreparatoryConsultation',
  BOOK_FIRST_TIME_INTAKE_MEDICATION_ONE = 'bookFirstTimeIntakeMedicationOne',
  BOOK_FIRST_TIME_INTAKE_MEDICATION_TWO = 'bookFirstTimeIntakeMedicationTwo',
  BOOK_FIRST_TIME_INTAKE_MEDICATION_THREE = 'bookFirstTimeIntakeMedicationThree',
  START_TAKING_MEDICATION_ONE = 'startTakingMedicationOne',
  START_TAKING_MEDICATION_TWO = 'startTakingMedicationTwo',
  START_TAKING_MEDICATION_THREE = 'startTakingMedicationThree',
  CHECK_IN_MEDICATION_ONE = 'checkInMedicationOne',
  CHECK_IN_MEDICATION_TWO = 'checkInMedicationTwo',
  CHECK_IN_MEDICATION_THREE = 'checkInMedicationThree',
  GET_ONE_YEAR_MEDICATION_ONE = 'getOneYearMedicationOne',
  GET_ONE_YEAR_MEDICATION_TWO = 'getOneYearMedicationTwo',
  GET_ONE_YEAR_MEDICATION_THREE = 'getOneYearMedicationThree',
}

export enum NutritionAdviceStepIds {
  ANSWER_HEALTH_QUESTIONNAIRE = 'answerHealthQuestionnaire',
  COMPLETE_FOOD_JOURNAL = 'completeFoodJournal',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_ONE = 'bookConsultationWithNutritionistOne',
  RECEIVE_NUTRITION_PLAN_ONE = 'receiveNutritionPlanOne',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_TWO = 'bookConsultationWithNutritionistTwo',
  RECEIVE_NUTRITION_PLAN_TWO = 'receiveNutritionPlanTwo',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_THREE = 'bookConsultationWithNutritionistThree',
  RECEIVE_NUTRITION_PLAN_THREE = 'receiveNutritionPlanThree',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_FOUR = 'bookConsultationWithNutritionistFour',
  RECEIVE_NUTRITION_PLAN_FOUR = 'receiveNutritionPlanFour',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_FIVE = 'bookConsultationWithNutritionistFive',
  RECEIVE_NUTRITION_PLAN_FIVE = 'receiveNutritionPlanFive',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_SIX = 'bookConsultationWithNutritionistSix',
  RECEIVE_NUTRITION_PLAN_SIX = 'receiveNutritionPlanSix',
  BOOK_CONSULTATION_WITH_NUTRITIONIST_SEVEN = 'bookConsultationWithNutritionistSeven',
  RECEIVE_NUTRITION_PLAN_SEVEN = 'receiveNutritionPlanSeven',
  PURCHASE_FOLLOW_ON_CONSULTATIONS = 'purchaseFollowOnConsultations',
}

export const STEP_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

export const STEP_TYPE = {
  BOOKING: 'booking',
  MEDICATION: 'medication',
  LINK: 'link',
  BUTTON: 'button',
  PRODUCT: 'product',
};

export const TREATMENT_DOWNLOAD_BUTTON_TYPES = {
  DOWNLOAD_TREATMENT_PRESCRIPTION: 'downloadTreatmentPrescription',
  DOWNLOAD_ACTION_PLAN: 'downloadActionPlan',
  DOWNLOAD_SESSION_DOCUMENTATION: 'downloadSessionDocumentation',
};
